import React from 'react';

import '../../css/Home.css';
import { branches, DentalPuenteBranch, getOpenStreetMapUrl } from '../data/branches';

type MapContainerProps = {
  branch?: DentalPuenteBranch;
};

const MapContainer: React.FC<MapContainerProps> = ({ branch = branches[0] }) => {
  const { lat, lng } = branch.coordinates;
  const delta = 0.0022;

  const bbox = [
    lng - delta,
    lat - delta,
    lng + delta,
    lat + delta,
  ].join('%2C');

  const marker = `${lat}%2C${lng}`;
  const mapSrc = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${marker}`;
  const openMapUrl = getOpenStreetMapUrl(branch);

  return (
    <section className="osmMapCard" aria-label={`Mapa de ubicación de ${branch.name}`}>
      <iframe
        className="osmMapFrame"
        title={`Mapa - ${branch.name}`}
        src={mapSrc}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
      <div className="osmMapFooter">
        <span>{branch.shortName}</span>
        <a href={openMapUrl} target="_blank" rel="noreferrer">
          Abrir mapa
        </a>
      </div>
    </section>
  );
};

export default MapContainer;
